var _rect, _rect2, _path, _circle, _circle2, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6.679 10.696h47.243v41.482H6.679z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.898,
    cy: 16.457,
    r: 2.305,
    fill: "#E95832"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.857,
    cy: 16.457,
    r: 2.305,
    fill: "#E95832"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.984,
    y: 24.523,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.984,
    y: 38.351,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.963,
    y: 24.523,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#step_2_svg__clip0_45710_5372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 28.25l-4.125 4.125L27.5 30.5",
    stroke: "#E95832",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.963,
    y: 38.351,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.943,
    y: 24.523,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.943,
    y: 38.351,
    width: 12.675,
    height: 11.523,
    rx: 1,
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "step_2_svg__clip0_45710_5372"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(26 26)",
    d: "M0 0h9v9H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/step_2.918256d4.svg";
export { SvgStep2 as ReactComponent };